export const CashBankCoa = {
  ACC_CASH: 110100,
  ACC_BANK: 110200,
}
export const Coa = {
  CASH_BOTTOM_BOUND: 110100,
  PETTY_CASH: 110102,
  CASH_UPPER_BOUND: 110200,
  BANK_BOTTOM_BOUND: 110200,
  BANK_UPPER_BOUND: 110300,
  INVESTATION_BOTTOM_BOUND: 110300,
  INVESTATION_UPPER_BOUND: 110500,

  ACC_RECEIVABLE: 110500,
  ACC_STOCK: 110900,
  // TODO might as well define bounds for other accounts
  ASSET_BOTTOM_BOUND: 110000,
  ASSET_UPPER_BOUND: 200000,

  FIXED_ASSET_BOTTOM_BOUND: 120000,
  FIXED_ASSET_UPPER_BOUND: 130000,

  LIABILITY_BOTTOM_BOUND: 210000,
  LIABILITY_UPPER_BOUND: 300000,

  SAVING_BOTTOM_BOUND: 210100,
  SAVING_UPPER_BOUND: 210200,
  VOLUNTEER_SAVINGS: 210101,
  HOLYDAY_SAVINGS: 210102,
  EDUCATION_SAVINGS: 210103,

  GARDEN_FARMER_PAYABLE: 210200,
  TRADE_PAYABLE: 210500,
  NON_TRADE_PAYABLE_BOTTOM_BOUND: 211100,
  ACC_HUTANG_PIHAK_KETIGA: 220100,
  NON_TRADE_PAYABLE_UPPER_BOUND: 230000,

  EQUITY_BOTTOM_BOUND: 310000,
  EQUITY_UPPER_BOUND: 400000,

  MEMBER_CAPITAL_BOTTOM_BOUND: 310000,
  MEMBER_CAPITAL_UPPER_BOUND: 310300,
  PRINCIPAL_SAVINGS: 310100,
  MANDATORY_SAVINGS: 310200,
  INCOME_STATEMENT_ACCUMULATION: 330000,

  INCOME_BOTTOM_BOUND: 400000,
  INCOME_UPPER_BOUND: 500000,

  OPERATIONAL_INCOME_BOTTOM_BOUND: 400000,
  OPERATIONAL_INCOME_UPPER_BOUND: 420000,

  NON_OPERATIONAL_INCOME_BOTTOM_BOUND: 500000,
  NON_OPERATIONAL_INCOME_UPPER_BOUND: 520000,

  EXPENSE_BOTTOM_BOUND: 500000,
  EXPENSE_UPPER_BOUND: 600000,

  OPERATIONAL_EXPENSE_BOTTOM_BOUND: 420100,
  OPERATIONAL_EXPENSE_UPPER_BOUND: 420200,

  NON_OPERATIONAL_EXPENSE_BOTTOM_BOUND: 520000,
  ACC_LABA_RUGI: 530000,
  ACC_NET_PROFIT: 550000,
  NON_OPERATIONAL_EXPENSE_UPPER_BOUND: 600000,
  //fake accoun,just for help reporting
  BALANCE_SHEET_SUMMARY: 399000,
  TOTAL_OPERATIONAL_INCOME: 419990,
  TOTAL_OPERATIONAL_EXPENSES: 429900,
  INCOME_AFTER_OPERATIONAL_EXPENSES: 429991,
  TOTAL_OTHER_INCOME_AND_EXPENSES: 519990,
  PROFIT_BEFORE_TAX: 540499,
  CORPORATE_TAX_PAYABLE: 540500,
  PROFIT_AFTER_TAX: 550000,
  TOTAL_SUMMARY: 699999,
}

export const Gender = {
  Male: 0,
  Female: 1,
}

export const MaritalStatus = {
  Single: 0,
  Married: 1,
  Divorced: 2,
}

export const UserStatus = {
  Pending: 0,
  Activated: 1,
  Deactivated: 2,
  Deleted: 3,
}

export const ProductType = {
  Product: 1,
  DirectMaterial: 2,
}

export const ProductionType = {
  NEW: 1,
  REPACK: 2,
  REPAIR: 3,
}

export const ProductSaleOrderStatus = {
  PENDING: 1,
  PAID: 2,
  PRINT: 3,
  SEND: 4,
  OK: 5,
}

export const BankTransaction = {
  DEPOSIT: 1,
  WITHDRAWAL: 2,
  ADMINISTRATIVE_COST: 3,
  INTEREST: 4,
  TRANSFER: 5,
}

export const CodeMarketerDept = 'DPT0000005'

export const UserStatusLabel = {
  [UserStatus.Pending]: 'Pending',
  [UserStatus.Activated]: 'Activated',
  [UserStatus.Deactivated]: 'Deactivated',
  [UserStatus.Deleted]: 'Deleted',
}

export const UserStatusColor = {
  [UserStatus.Pending]: 'warning',
  [UserStatus.Activated]: 'success',
  [UserStatus.Deactivated]: 'danger',
  [UserStatus.Deleted]: 'danger',
}

export const SavingStatus = {
  Active: 0,
  Closed: 1,
  Blocked: 2,
}

export const SavingStatusLabel = {
  [SavingStatus.Active]: 'Active',
  [SavingStatus.Closed]: 'Closed',
  [SavingStatus.Blocked]: 'Bloked',
}

export const SavingStatusColor = {
  [SavingStatus.Active]: 'success',
  [SavingStatus.Closed]: 'danger',
  [SavingStatus.Blocked]: 'danger',
}

export const SavingTransaction = {
  DEPOSIT: 1,
  WITHDRAWAL: 2,
  SAVING_INTEREST: 3,
  ADMINISTRATIVE_COST: 4,
  CLOSING: 5,
  CLOSING_COST: 6,
  TERM_SAVING_INTEREST: 33,
}

export const DeptCode = {
  CODE_DEPT_PENGAWAS: 'DPT0000001',
  CODE_DEPT_PENGURUS: 'DPT0000002',
  CODE_DEPT_MANAJER: 'DPT0000003',
  CODE_DEPT_KEUANGAN: 'DPT0000004',
  CODE_DEPT_PEMBELIAN: 'DPT0000005',
  CODE_DEPT_PEMASARAN: 'DPT0000006',
  CODE_DEPT_PERSONALIA: 'DPT0000007',
}

export const Style = {
  fontSize: 14,
  size: 'sm',
}

export const AppSetting = {
  GENERAL: 3,
  PRODUCT_PURCHASE: 1,
  PRODUCT_SALE: 2,

  //sales
  DIRECT_SALE: 21,
  USE_TAX: 22,
  USE_FARM_TAX: 23,
  SALES_OVER_PAY_INTO_ACCOUNT_RECEIVABLE: 24,

  //purchase
  DIRECT_PURCHASE: 11,
  TAX_INTO_CGS: 12,
  SHIPPING_COST_INTO_CGS: 13,
  PURCHASE_OVER_PAY_INTO_DEBT: 14,

  //general
  SUPPLIER_BALANCE_CHECK: 31,
  CUSTOMER_BALANCE_CHECK: 32,
  USE_POINT: 33,
  DROPSHIP: 34,
  BEGINNING_BALANCE: 35,
  BACK_DATE: 36,
}

export const SupplierCategory = {
  MEMBER_SUPPLIER: 1,
  PUBLIC_SUPPLIER: 0,
}

export const TransactionType = {
  TUNAI: 'Tunai',
  TEMPO: 'Tempo',
  TEMPO_WITH_DP: 'Tempo dengan DP',
}

export const ProductInvestationStatus = {
  Posted: 1,
  Pending: 2,
}

export const ProductInvestationStatusLabel = {
  [ProductInvestationStatus.Posted]: 'Posted',
  [ProductInvestationStatus.Pending]: 'Pending',
}

export const ProductInvestationStatusColor = {
  [ProductInvestationStatus.Posted]: 'success',
  [ProductInvestationStatus.Pending]: 'warning',
}

export const BeginningBalance = {
  BB_FLAG: 3,
}

export const GroupUserType = {
  GROUP_TRUSTIE_TYPE: 1,
  GROUP_EMPLOYEE_TYPE: 2,
  GROUP_MEMBER_TYPE: 3,
}

export const GroupIndex = {
  SUPERUSER_IDX: 1,
  ADMIN_IDX: 2,
  TRUSTIE_IDX: 3,
  MANAGER_IDX: 4,
  MEMBER_IDX: 5,
  STAFF_ADMINISTRASI_IDX: 6,
  STAFF_FINANCE_IDX: 7,
  MARKETING_IDX: 8,
}

export const EmployeeStatus = {
  EMPLOYEE_PENDING: 0,
  EMPLOYEE_ACTIVATED: 1,
  EMPLOYEE_DEACTIVATED: 2,
}

export const EmployeeStatusLabel = {
  [EmployeeStatus.EMPLOYEE_PENDING]: 'Pending',
  [EmployeeStatus.EMPLOYEE_ACTIVATED]: 'Aktif',
  [EmployeeStatus.EMPLOYEE_DEACTIVATED]: 'Non Aktif',
}

export const EmployeeStatusColor = {
  [EmployeeStatus.EMPLOYEE_PENDING]: 'warning',
  [EmployeeStatus.EMPLOYEE_ACTIVATED]: 'success',
  [EmployeeStatus.EMPLOYEE_DEACTIVATED]: 'danger',
}

export const UserType = {
  USER_TRUSTIE_TYPE: 1,
  USER_EMPLOYEE_TYPE: 2,
  USER_MEMBER_TYPE: 3,
}

export const DeptGroup = {
  DEPT_TRUSTIE_GROUP: 1,
  DEPT_EMPLOYEE_GROUP: 2,
}

export const MemberStatus = {
  MEMBER_PENDING: 0,
  MEMBER_ACTIVATED: 1,
  MEMBER_DEACTIVATED: 2,
}

export const MemberStatusLabel = {
  [MemberStatus.MEMBER_PENDING]: 'Pending',
  [MemberStatus.MEMBER_ACTIVATED]: 'Aktif',
  [MemberStatus.MEMBER_DEACTIVATED]: 'Keluar',
}

export const MemberStatusColor = {
  [MemberStatus.MEMBER_PENDING]: 'warning',
  [MemberStatus.MEMBER_ACTIVATED]: 'success',
  [MemberStatus.MEMBER_DEACTIVATED]: 'danger',
}

export const TbsSaleStatus = {
  STATUS_REVERT: 0,
  STATUS_OK: 1,
  STATUS_PENDING: 2,
}

export const TbsSaleStatusLabel = {
  [TbsSaleStatus.STATUS_PENDING]: 'Pending',
  [TbsSaleStatus.STATUS_OK]: 'Selesai',
  [TbsSaleStatus.STATUS_REVERT]: 'Jurnal Balik',
}

export const TbsSaleStatusColor = {
  [TbsSaleStatus.STATUS_PENDING]: 'warning',
  [TbsSaleStatus.STATUS_OK]: 'success',
  [TbsSaleStatus.STATUS_REVERT]: 'danger',
}

export const TbsInvoiceStatus = {
  STATUS_REVERT: 0,
  STATUS_OK: 1,
  STATUS_PENDING: 2,
  STATUS_INSTALLED: 3,
}

export const TbsInvoiceStatusLabel = {
  [TbsInvoiceStatus.STATUS_PENDING]: 'Pending',
  [TbsInvoiceStatus.STATUS_OK]: 'Lunas',
  [TbsInvoiceStatus.STATUS_REVERT]: 'Jurnal Balik',
  [TbsInvoiceStatus.STATUS_INSTALLED]: 'Diangsur',
}

export const TbsInvoiceStatusColor = {
  [TbsInvoiceStatus.STATUS_PENDING]: 'warning',
  [TbsInvoiceStatus.STATUS_OK]: 'success',
  [TbsInvoiceStatus.STATUS_REVERT]: 'danger',
  [TbsInvoiceStatus.STATUS_INSTALLED]: 'success',
}

export const TbsSaleIsInvoiced = {
  IS_NOT_INVOICED: 0,
  IS_INVOICED: 1,
  IS_PAYED: 2,
}

export const TbsInvoicePay = {
  PAY: 0,
  REVERT: 1,
  REVERTED: 2,
}

export const TbsInvoicePayLabel = {
  [TbsInvoicePay.PAY]: 'Bayar',
  [TbsInvoicePay.REVERT]: 'Jurnal Balik',
  [TbsInvoicePay.REVERTED]: 'Bayar/Jurnal Balik',
}

export const TbsInvoicePayColor = {
  [TbsInvoicePay.REVERT]: 'warning',
  [TbsInvoicePay.PAY]: 'success',
  [TbsInvoicePay.REVERTED]: 'danger',
}
